import _styled2 from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
export const OnlineStatusLabelStyled = /*#__PURE__*/_styled2("span", process.env.NODE_ENV === "production" ? {
  target: "enbajrp0"
} : {
  target: "enbajrp0",
  label: "OnlineStatusLabelStyled"
})(process.env.NODE_ENV === "production" ? {
  name: "1h52dri",
  styles: "overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
} : {
  name: "1h52dri",
  styles: "overflow:hidden;text-overflow:ellipsis;white-space:nowrap",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkQ6XFxhXFwxXFxzXFxzcmNcXGNvbXBvbmVudHNcXGtpdFxcb25saW5lLXN0YXR1cy1sYWJlbFxcc3R5bGVkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUV1QyIsImZpbGUiOiJEOlxcYVxcMVxcc1xcc3JjXFxjb21wb25lbnRzXFxraXRcXG9ubGluZS1zdGF0dXMtbGFiZWxcXHN0eWxlZC50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0dywgeyBzdHlsZWQgfSBmcm9tICd0d2luLm1hY3JvJztcclxuXHJcbmV4cG9ydCBjb25zdCBPbmxpbmVTdGF0dXNMYWJlbFN0eWxlZCA9IHN0eWxlZC5zcGFuKHR3YFxyXG4gIHRydW5jYXRlXHJcbmApO1xyXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});